import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-app bg-grey-50" }
const _hoisted_2 = { class: "s20" }
const _hoisted_3 = { class: "widget shadow-100 s20 pb-2" }
const _hoisted_4 = { class: "container-full-2 s20 my-5" }
const _hoisted_5 = { class: "s13 flex justify-content-right" }
const _hoisted_6 = { class: "custom-filter-set-area" }
const _hoisted_7 = { class: "table separator skin3 selection rounded" }
const _hoisted_8 = {
  class: "btn-circle",
  for: "check_all"
}
const _hoisted_9 = ["checked"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  colspan: "6",
  class: "text-center py-5"
}
const _hoisted_12 = {
  key: 0,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "selection-item" }
const _hoisted_15 = ["for"]
const _hoisted_16 = ["id", "value"]
const _hoisted_17 = { style: {"width":"25%"} }
const _hoisted_18 = { class: "text-xl font-semibold mb-2" }
const _hoisted_19 = {
  class: "text-2xl",
  style: {"width":"20%"}
}
const _hoisted_20 = { class: "text-2xl color-success" }
const _hoisted_21 = { class: "flex-right gap-4" }
const _hoisted_22 = { style: {"display":"flex","flex-direction":"row","justify-content":"center"} }
const _hoisted_23 = { key: 0 }

import { computed, onMounted, reactive, ref, toRaw } from 'vue';
    import axios from 'axios';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
    import OnboardingGroupeComponent from '../onboarding-groupe/components/OnboardingGroupeComponent.vue';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesListView',
  setup(__props) {

    const errorMessage = ref('');
    const loading = ref(false);
    const itemsList = ref([] as any[]);
    const selectedItem = ref(null as any);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const selectedItems = ref([] as any[]);
    const areAllItemsSelected = computed(() => {
        return itemsList.value.length == selectedItems.value.length;
    });
    const queryParams = reactive({
        pageNumber: 1,
        sortDir: 'ASC',
        sortColumn: 'nom',
        sortOption: 'nom_asc',
        borneInf: '',
        borneSup: '',
        pays_id: '',
        search: '',
        trashed: 0
    });
    const pagination = reactive({
        total: 0,
        per_page: 10,
        last_page: 1
    });
    const SORT_OPTIONS = [
        { value: 'nom_asc', label: 'Nom (ASC)', sort_column: 'nom', sort_direction: 'ASC' },
        { value: 'nom_desc', label: 'Nom (DESC)', sort_column: 'nom', sort_direction: 'DESC' },
        { value: 'created_at_asc', label: 'Date (ASC)', sort_column: 'created_at', sort_direction: 'ASC' },
        { value: 'created_at_desc', label: 'Date (DESC)', sort_column: 'created_at', sort_direction: 'DESC' },
    ];
    const showAdvancedFilters = ref(false);
    const isOnboardingModalOpened = ref(false);

    onMounted(() => {
        doListItems();
    });

    async function doListItems() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const queryParamsRaw = toRaw(queryParams);
            const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
            const httpResponse = await axios.get(`/backoffice/collectivites/list?${queryString}`);
            itemsList.value = httpResponse.data.data;
            pagination.total = httpResponse.data.total;
            pagination.per_page = httpResponse.data.per_page;
            pagination.last_page = httpResponse.data.last_page;
        } catch (error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }

    function onPaginate(pageNumber: number) {
        queryParams.pageNumber = pageNumber;
        doListItems();
    }

    async function doDeleteItem(item: any) {
        const confirmation = await confirmationModalRef.value?.open("Collectivités", "Voulez-vous vraiment supprimer l'élément sélectionné ?");
        if (confirmation) {
            try {
                loading.value = true;
                errorMessage.value = '';
                await axios.post(`/backoffice/collectivites/destroy/${item.id}`, {});
                const index = itemsList.value.findIndex(i => i.id == item.id);
                if (index > -1) {
                    const itemsListCloned = itemsList.value;
                    itemsListCloned.splice(index, 1);
                    itemsList.value = itemsListCloned;
                }
            } catch(error: any) {
                errorMessage.value = error.message;
            } finally {
                loading.value = false;
            }
        }
    }

    function handleCheckAll(_event: any) {
        const checked = _event.target.checked;
        if (checked) {
            selectedItems.value = itemsList.value.map(i => i.id);
        } else {
            selectedItems.value = [];
        }
    }

    function toggleAdvancedFilters() {
        showAdvancedFilters.value = !showAdvancedFilters.value;
    }

    function doOpenOnboardingModal(item: any) {
        selectedItem.value = item;
        isOnboardingModalOpened.value = true;
    }

    function onOnboardingModalClosed() {
        selectedItem.value = null;
        isOnboardingModalOpened.value = false;
    }

    function onOnboardingCompleted() {
        selectedItem.value = null;
        isOnboardingModalOpened.value = false;
        doListItems();
    }


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_custom_pagination = _resolveComponent("custom-pagination")!
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[33] || (_cache[33] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "s7" }, [
            _createElementVNode("h4", { class: "font-semibold mt-4" }, [
              _createTextVNode("Collectivites "),
              _createElementVNode("span", { class: "text-sm text-grey-500" }, "(recent)")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/app/collectivites/form" }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("button", {
                  id: "btn-add",
                  class: "btn normal ml-4 justify-content-center btn-filtre"
                }, [
                  _createElementVNode("img", {
                    src: "/icons/icon-add.svg",
                    class: "btn-icon",
                    alt: ""
                  }),
                  _createElementVNode("span", null, "Créer")
                ], -1)
              ]))]),
              _: 1
            }),
            _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"form-field-floating default sm s4_mobile ml-3\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\">Trier</option><option value=\"\" selected>Ordre Décroissant</option><option value=\"\">Ordre Croissant</option><option value=\"\">De A - Z</option><option value=\"\">De Z - A</option></select></div>", 1)),
            _createElementVNode("button", {
              onClick: toggleAdvancedFilters,
              class: "btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter"
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("img", {
                src: "/icons/icon-filter.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Options", -1)
            ]))])
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
          _withDirectives(_createElementVNode("div", _hoisted_6, [...(_cache[6] || (_cache[6] = [
            _createStaticVNode("<div class=\"grid-filter6 mt-4 mb-0\"><div class=\"form-field-floating reactive sm\"><input type=\"date\" class=\"form-input\" name=\"date1\" id=\"date1\" placeholder=\"\"><label for=\"date1\">Date de création &lt;=</label></div><div class=\"form-field-floating reactive sm\"><input type=\"date\" class=\"form-input\" name=\"date2\" id=\"date2\" placeholder=\"\"><label for=\"date2\">Date de création &gt;=</label></div><div class=\"form-field-floating sm\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\" selected>Tout les etats</option><option value=\"\">Actif</option><option value=\"\">Inactif</option></select><label for=\"pays\">Etat <b class=\"color-danger\">*</b></label></div><div class=\"form-field-floating sm\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\" selected>Tout les etats</option><option value=\"\">Actif</option><option value=\"\">Inactif</option></select><label for=\"pays\">Etat <b class=\"color-danger\">*</b></label></div><button class=\"btn black normal justify-content-center mx-0 btn-filtre\"><img src=\"/icons/icon-excel.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter Excel</span></button><button class=\"btn black normal justify-content-center mx-0 btn-filtre\"><img src=\"/icons/icon-pdf.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter PDF</span></button></div>", 1)
          ]))], 512), [
            [_vShow, showAdvancedFilters.value]
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                _createElementVNode("label", _hoisted_8, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: "check_all",
                    checked: areAllItemsSelected.value,
                    onChange: handleCheckAll
                  }, null, 40, _hoisted_9)
                ])
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("th", null, null, -1)),
              _cache[10] || (_cache[10] = _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Information")
              ], -1)),
              _cache[11] || (_cache[11] = _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Membres")
              ], -1)),
              _cache[12] || (_cache[12] = _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Prélèvement")
              ], -1)),
              _cache[13] || (_cache[13] = _createElementVNode("th", { class: "flex-right" }, [
                _createElementVNode("button", { class: "btn-ultra color2" }, [
                  _createElementVNode("div", { class: "btn-show" }, [
                    _createElementVNode("img", {
                      src: "/icons/icon-actif.svg",
                      class: "btn-icon",
                      alt: ""
                    }),
                    _createElementVNode("span", null, "Actif")
                  ]),
                  _createElementVNode("div", { class: "btn-loading" }, [
                    _createElementVNode("div", { class: "loader-dots" })
                  ])
                ])
              ], -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                  _createElementVNode("td", _hoisted_11, [
                    (loading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[14] || (_cache[14] = [
                          _createElementVNode("div", { class: "loader dark" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (itemsList.value.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("td", {
                      colspan: "6",
                      class: "text-center py-5"
                    }, " Aucune collectivité trouvée. ", -1)
                  ]))]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(itemsList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "text-grey-700 over-effect",
                      key: 'item_' + index
                    }, [
                      _createElementVNode("td", _hoisted_14, [
                        _createElementVNode("label", {
                          class: "btn-circle",
                          for: 'item_check_' + index
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            name: "selectedItems[]",
                            id: 'item_check_' + index,
                            value: item.id,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedItems).value = $event))
                          }, null, 8, _hoisted_16), [
                            [_vModelCheckbox, selectedItems.value]
                          ])
                        ], 8, _hoisted_15)
                      ]),
                      _cache[28] || (_cache[28] = _createElementVNode("td", { class: "flex" }, [
                        _createElementVNode("div", {
                          class: "square-xxl rounded-15 ml-3 px-3 py-3",
                          style: {"background-color":"rgb(var(--color-black-rgb), 0.04)"}
                        }, [
                          _createElementVNode("img", {
                            src: "/assets/logos/logo6.svg",
                            width: "100%"
                          })
                        ])
                      ], -1)),
                      _createElementVNode("td", _hoisted_17, [
                        _createElementVNode("p", _hoisted_18, [
                          _createTextVNode(_toDisplayString(item.nom) + " ", 1),
                          _cache[16] || (_cache[16] = _createElementVNode("br", { class: "mb-3" }, null, -1)),
                          _cache[17] || (_cache[17] = _createTextVNode(" C788PMKJ   ", -1)),
                          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "tag-state notif stroke" }, "Actif", -1))
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_19, [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(item.users_count), 1),
                        _cache[19] || (_cache[19] = _createTextVNode("/50000 ", -1)),
                        _cache[20] || (_cache[20] = _createElementVNode("p", { class: "mt-1" }, "Membres", -1))
                      ]),
                      _cache[29] || (_cache[29] = _createElementVNode("td", {
                        class: "font-semibold",
                        style: {"width":"20%"}
                      }, [
                        _createTextVNode(" Janvier 2024"),
                        _createElementVNode("br", { class: "mb-5" }),
                        _createElementVNode("span", { class: "tag-state danger stroke" }, "Pas à jour")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_router_link, {
                            to: '/app/collectivites/form/' + item.id
                          }, {
                            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                              _createElementVNode("button", { class: "btn tips" }, [
                                _createElementVNode("img", {
                                  src: "/icons/icon-edit.svg",
                                  class: "btn-icon",
                                  alt: ""
                                }),
                                _createElementVNode("span", null, "Editer")
                              ], -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"]),
                          _cache[27] || (_cache[27] = _createStaticVNode("<button class=\"btn-ultra color2 tips\"><div class=\"btn-show\"><img src=\"/icons/icon-actif.svg\" class=\"btn-icon\" alt=\"\"><span>Actif</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button>", 1)),
                          _createVNode(_component_router_link, {
                            to: '/app/collectivites/onboarding-groupe/' + item.id
                          }, {
                            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                              _createElementVNode("button", { class: "btn white2 active" }, [
                                _createElementVNode("img", {
                                  src: "/icons/icon-consulter.svg",
                                  class: "btn-icon",
                                  alt: ""
                                }),
                                _createElementVNode("span", null, "Onboarding")
                              ], -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"]),
                          _createVNode(_component_router_link, {
                            to: '/app/collectivites/' + item.id + '/details'
                          }, {
                            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                              _createElementVNode("button", { class: "btn white2 active" }, [
                                _createElementVNode("img", {
                                  src: "/icons/icon-consulter.svg",
                                  class: "btn-icon",
                                  alt: ""
                                }),
                                _createElementVNode("span", null, "Gérer")
                              ], -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"]),
                          _createVNode(_component_router_link, {
                            to: '/app/users/list?collectivite_id=' + item.id
                          }, {
                            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                              _createElementVNode("button", { class: "btn white2 active" }, [
                                _createElementVNode("img", {
                                  src: "/icons/icon-consulter.svg",
                                  class: "btn-icon",
                                  alt: ""
                                }),
                                _createElementVNode("span", null, "Membres")
                              ], -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"]),
                          _createVNode(_component_router_link, {
                            to: '/app/prospects/list?collectivite_id=' + item.id
                          }, {
                            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                              _createElementVNode("button", { class: "btn white2 active" }, [
                                _createElementVNode("img", {
                                  src: "/icons/icon-consulter.svg",
                                  class: "btn-icon",
                                  alt: ""
                                }),
                                _createElementVNode("span", null, "Prospects"),
                                _createTextVNode("   "),
                                _createElementVNode("span", { class: "text-3xl color-danger" }, "(12)")
                              ], -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"]),
                          _createVNode(_component_router_link, {
                            to: '/app/finance/prelevements/' + item.id
                          }, {
                            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                              _createElementVNode("button", { class: "btn white2 active" }, [
                                _createElementVNode("img", {
                                  src: "/icons/icon-consulter.svg",
                                  class: "btn-icon",
                                  alt: ""
                                }),
                                _createElementVNode("span", null, "Prélèvements")
                              ], -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ])
                    ]))
                  }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_custom_pagination, {
            modelValue: queryParams.pageNumber,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((queryParams.pageNumber) = $event)),
              onPaginate
            ],
            total: pagination.total,
            "per-page": pagination.per_page,
            last_page: pagination.last_page
          }, null, 8, ["modelValue", "total", "per-page", "last_page"])
        ])
      ]),
      _cache[30] || (_cache[30] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
    ]),
    _cache[34] || (_cache[34] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
    _createVNode(ConfirmationModal, {
      ref_key: "confirmationModalRef",
      ref: confirmationModalRef
    }, null, 512),
    _createVNode(_component_custom_modal, {
      classesNames: 'modal-lg',
      show: isOnboardingModalOpened.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((isOnboardingModalOpened).value = $event)),
      onClosed: onOnboardingModalClosed
    }, {
      header: _withCtx(() => [...(_cache[31] || (_cache[31] = [
        _createTextVNode(" ", -1)
      ]))]),
      footer: _withCtx(() => [...(_cache[32] || (_cache[32] = [
        _createTextVNode(" ", -1)
      ]))]),
      default: _withCtx(() => [
        (selectedItem.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createVNode(OnboardingGroupeComponent, {
                "is-widget-mode": false,
                collectivite: selectedItem.value,
                onCompleted: onOnboardingCompleted
              }, null, 8, ["collectivite"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})